
<div class="card">
  <div class="card-header">
      <h4>Edit Product Category</h4>
  </div>
  <form #categoryEdit="ngForm" (ngSubmit)="editCategory(categoryEdit.value)" [formGroup]="editCategoryForm">
  <div class="row">
      <div class="col-sm-6 mb-3 mb-sm-0">
        <div class="card border-0 shadow-none text-center">
          <div class="card-body ">
              <img [src]="selectedFile"  width="150" height="150" class="rounded-circle mb-3" alt="category Image">
              <br>
              <div class="custom-file" *ngIf="permissions.includes('Edit')" >
                <div class="file btn btn-lg bg-primary">
              Upload &nbsp;<i class="fa fa-upload"></i>
              <input type="file" [ngClass]="{'is-invalid':submitted && editCategoryForm.controls.categoryImage.errors}" accept="image/*" (change)="setCategoryProfile($event)" name="categoryImage">
              </div>
              </div>
              <div class="invalid-feedback mt-2" style="display: block;" id="fileNameDisplay"
                          *ngIf="submitted && editCategoryForm.controls.categoryImage.errors">
                          <div *ngIf="editCategoryForm.controls.categoryImage.errors?.required">
                            Icon is required.
                          </div>
                      </div>
                  
              <a href="javascript:void(0)" *ngIf="editCategoryForm.get('categoryImage')?.valid && permissions.includes('Edit')"  (click)="removeFile()"
                          class="position-absolute" style="top: 10px; right: 180px; color: #dc3545;">
                          <i class="fa fa-times-circle fa-lg"></i>
              </a>
              <p style="font-size: 13px; margin-top: 4px;">PNG/JPG with max size 50 KB allowed.</p>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card border-0 shadow-none text-center">
          <div class="card-body">
              <br>
              <br>
              <p class="card-text">Here's how it will look on Mobile App </p>
              <br>
              <img src="assets\images\app-productCategory.png" width="300" height="80" class=" mb-3" alt="...">
            
          </div>
        </div>
      </div>
  </div>
  <hr >
  <div class="row">
    <div class="col-lg-12">
      <div class="card border-0 shadow-none text-center">
        <div class="card-body">
          <div class="row d-flex">
              <div class="form-group col-md-3 ">
                  <label class="col-form-label" for="categoryName">Category Name <span aria-hidden="true"
                          class="symbol required" style="color:red;">*</span>
                  </label>
                  <input type="text" id="categoryName" autocomplete="off" class="form-control" [readonly]="!permissions.includes('Edit')" required formControlName="categoryName" placeholder="Enter Category Name" [ngClass]="{'is-invalid':submitted && editCategoryForm.controls.categoryName.errors}" (keypress)="onCategoryNameKeyPress($event)" ngModel name="categoryName">
                  <div class="invalid-feedback">
                    Category is required
                    </div>
              </div>
              <div class="form-group col-md-3">
                  <label class="col-form-label" for="categoryDesc">Category Description <span aria-hidden="true"
                          class="symbol required" style="color:red;">*</span>
                  </label>
                  <input type="text" class="form-control" autocomplete="off" [readonly]="!permissions.includes('Edit')" required formControlName="categoryDesc" placeholder="Enter Category Description" [ngClass]="{'is-invalid':submitted && editCategoryForm.controls.categoryDesc.errors}" (keypress)="onCategoryDescKeyPress($event)" ngModel name="categoryDesc">
                  <div class="invalid-feedback">
                          Category Description is required
                  </div>
              </div>
              
          </div>
          <div class="row d-flex">
            <div class="form-group col-md-3" *ngIf="!permissions.includes('Approve')">
              <label class="col-form-label">Status <span aria-hidden="true"
                  class="symbol required" style="color:red;">*</span></label>
              <input type="text" id="productName" readonly value="{{this.editCategoryForm.value.status | titlecase}}" class="form-control">
            </div>

              <div class="form-group col-md-3" *ngIf="permissions.includes('Approve')">
                  <label class="col-form-label" for="status">Status <span aria-hidden="true"
                          class="symbol required" style="color:red;">*</span>
                  </label>
                  <ng-select id="status" (change)="categoryStatusChange($event)" placeholder="Select Status" formControlName="status" required  [ngClass]="{'is-invalid':submitted && editCategoryForm.controls.status.errors}" name="status">
                      <ng-option value="ACTIVE">Active</ng-option>
                      <ng-option value="INACTIVE">Inactive</ng-option>
                    </ng-select>
                  <div class="invalid-feedback">
                      <div >
                          Status is required
                      </div>
                  </div>
              </div>
          </div>
            <div class="row d-flex">
                <div class="form-group col-md-12 text-right">
                    <button class="btn btn-primary" type="submit" *ngIf="permissions.includes('Edit')">Update</button>
                    <button class="btn btn-primary" type="button" (click)="statusUpdate()" *ngIf="permissions.includes('Approve')">Update</button>
                    <button class="btn btn-secondary" id="cancelButton" (click)="cancelButton()">Cancel</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>


<app-modal #editProductCategoryModalOpen [modalConfig]="modalProductCategory">
   
    <br>
    <h4 class="text-center">Are you sure ?</h4>
    <br>
    <p class="text-center">This action will change the status of associated <strong>ACTIVE </strong> Products</p>
    <hr class="new5">
    <div class="row">
        <div class="col-sm-3 mb-2 text-center" *ngFor="let subCategory of subCategoryMappedList;let i = index">
            <div class="card text-center border-light cardStyle scroll" style="max-height: 14rem; height: 14rem;">
                <div class="card-body">
                  <h5 class="card-header">{{subCategory.categoryName}}</h5>
                  <div *ngFor="let product of subCategory.productList;let j = index">
                    <p class="text-left" >{{j+1}}. {{product}}</p>
                  </div>
                  
                </div>
              </div>
        </div>
    </div>
    <br>
    

    <div class="row d-flex">
        <div class="form-group col-md-12 text-center">
            <button class="btn btn-primary" (click)="confirmModal()">Confirm</button>
            <button class="btn btn-secondary" id="cancelButton" (click)="closeModalBlocked($event)">Cancel</button>
        </div>
    </div>
      
</app-modal> 